import PrintButton from "components/Button/PrintButton";
import DatePicker from "components/Input/DatePicker";
import Dropdown from "components/Input/Dropdown";
import DailySalesReport from "components/modal/components/DailySalesReport";
import ConfirmationModal from "components/modal/ConfirmationModal";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DateInsertFormat, DropdownPageSizeOptions, DropdownStatusList, DropdownTransactionStatus, DropdownTransactionType, EmptyString, FormTypeAdd, FormTypeEdit, FormTypeView, PageSize, PaginationBack, PaginationFirst, PaginationLast, PaginationNext, StatusCodeActive, StatusCodeDelete } from "utils/Constant";
import { ApiGetDailyReport, ApiGetTransactionList, ApiGetUserLocationByUserId } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";

export default function DailyReport(){
    const { fetch: apiGetLocation } = useFetch(ApiGetUserLocationByUserId)
    const { fetch: apiGetDailyReport } = useFetch(ApiGetDailyReport)

    const [location, setLocation] = useState('')
    const [locationOptions, setLocationOptions] = useState([])
    const [periode, setPeriode] = useState(new Date())

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    const printBtnClickHandler = async () => {
        if (location === '') {
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                    }
                },
                message: "Lokasi harus dipilih"
            })

            return
        }

        try {
            setLoading({isOpen: true})

            const res = await fGetDailyReport()

            if (checkResponse(res)) {
                console.log(res)
                DailySalesReport(res.data, periode, locationOptions.find(x => x.value === location)?.label)
            }
        } 
        finally {
            setLoading({isOpen: false})
        }
    }

    // Function Api Call
    async function fGetLocationList(){
        await apiGetLocation({
            data: {
                userId: localStorage.getItem('Id')
            }
        }).then((response) => {
            if (checkResponse(response)) {
                let tempArray = []
                tempArray.push({label: "Pilih Lokasi", value: ""})

                for (let i = 0; i < response.data.length; i++){
                    tempArray.push({ label: response.data[i].locationName, value: String(response.data[i].locationId) })
                }

                setLocationOptions(tempArray)
                setLocation(tempArray[0].value)
            }
        })
    }
    async function fGetDailyReport(){
        let data = null
        
        await apiGetDailyReport({
            data: {
                locationId: location,
                periode: moment(periode).format("YYYY-MM-DD")
            }
        }).then((res) => {
            if (checkResponse(res)) {
                data = res
            }
        })

        return data
    }

    const checkResponse = (res) => {
        if(res.status === ApiResponseSuccess){
            return true
        }else if(res.status === ApiResponseStatusUnauthorized){
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                        window.location.href = "/login"
                    }
                },
                message: res.message
            })
            return false
        }else{
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                    }
                },
                message: res.message
            })
            return false
        }
    }

    useEffect(() => {
        const onLoad = async () => {
            setLoading({isOpen: true})

            try {
                let res = await fGetLocationList()
            }
            finally {
                setLoading({isOpen: false})
            }            
        }

        onLoad()        
    },[])

    return(
        <div className="flex flex-col gap-2 bg-white rounded-xl p-4 shadow-md h-full">
            <div >
                <span className="font-semibold text-2xl">Laporan Harian</span>
            </div>
            <hr />

            <div className="mt-4">
                <div className="w-full flex items-center py-2">
                    <div className="w-32">
                        <span>Periode</span>
                    </div>
                    <div className="px-2">
                        <span>:</span>
                    </div>
                    <div>
                        <DatePicker format='MMMM yyyy' value={periode} className='w-72 h-10' onChange={setPeriode} />
                    </div>
                </div>

                <div className="w-full flex items-center py-2">
                    <div className="w-32">
                        <span>Lokasi</span>
                    </div>
                    <div className="px-2">
                        <span>:</span>
                    </div>
                    <div>
                        <Dropdown className='w-72' options={locationOptions} value={location} onChange={(e) => setLocation(e.value)} placeholder="Pilih Lokasi" />
                    </div>
                </div>

                <div>
                    <PrintButton onClick={printBtnClickHandler} />
                </div>
            </div>
            
            {failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}

const FilterCard = ({title, children}) => {
    return (
        <div className="flex flex-col gap-1 w-full sm:w-[280px] text-sm sm:text-base">
            <span>{title}</span>
            {children}
        </div>
    )
}